import {VeedoPlayer} from './VeedoPlayer_class.js';

/**
 * UserLoggers logs the user login and ideally logoff to the 
 * Veedo proxy server
 */
export class UserLogger {
	constructor(el) {
		this.el = el;
		document.body.addEventListener(`veedo-user-name`, evt=>{
			this.userName(evt);
		});
		document.addEventListener("visibilitychange", () => {
		  if (document.visibilityState === "hidden") {
		  	this.userAction("hide");
		  } else if (document.visibilityState === "visible") {
		  	this.userAction("visible");
		  }
		});
		document.addEventListener(`beforeunload`, evt=>{
			evt.preventDefault(); // Prevent the default action
			this.userLeft();
		});
		// another way of trying to do the same
		window.addEventListener(`pagehide`, evt=>{
			this.userLeft();
		});
		this.pinger = null;
	}
	url(u) {
		if (this.el && this.el.hasAttribute(`data-url`)) {
			u = this.el.getAttribute(`data-url`) + u;
		}
		return u;
	}

	userName(evt) {
		this.detail = evt.detail;
		if (!this.detail.name){
			// get anonymous username!
			let vid = sessionStorage["veedo-user-id"];
			if (vid){
				let name = this.makeAnonFromId(vid);
				this.detail.name = name;
				this.detail.action = `join`;
				this.postDetail(this.detail);			
			} else {
				// console.log(`anonymous username anticipated, not posting details until veedo-anon-name event received`);
				document.addEventListener(`veedo-anon-name`, (evt) => {
					let vid = evt.detail;
					let name = this.makeAnonFromId(vid);
					this.detail.name = name;
					this.detail.action = `join`;
					this.postDetail(this.detail);			
				})	
			}
		} else {
			this.detail.action = `join`;
			this.postDetail(this.detail);
		}
		this.startPinger();
	}
	startPinger(){
		if (this.pinger == null) {
			console.log("New pinger");
			this.pinger = setInterval(() => {
				this.userPing();
			}, 30000);
		}
	}
	makeAnonFromId(vid){
		let parts = vid.split("-");
		let nid = parts[parts.length-1];
		nid = nid.replace(/0+/,"0");
		return "anon"+nid;
	}
	userLeft() {
		if (this.detail) {
			const detail = JSON.parse(JSON.stringify(this.detail));  // copy details
			detail.action = "left";
			detail.name = `*` + this.detail.name;	// we differentiate viewers with the *	- Mike: why?
			detail.uuid = this.getUUID();
			const postUrl = this.url(`${VeedoPlayer.Prefix}rest/user/action`);
			navigator.sendBeacon(postUrl, JSON.stringify(detail));
			//this.detail = null;  // no - we need to keep this!
		}
		if (this.pinger) {
			clearInterval(this.pinger);
			this.pinger = null;
		}
	}
	userAction(action) {
		if (this.detail) {
			const detail = JSON.parse(JSON.stringify(this.detail));  // copy details
			detail.action = action;
			detail.name = `*` + this.detail.name;	// we differentiate viewers with the *	- Mike: why?
			detail.uuid = this.getUUID();
			const postUrl = this.url(`${VeedoPlayer.Prefix}rest/user/action`);
			navigator.sendBeacon(postUrl, JSON.stringify(detail));
			//this.detail = null;  // no - we need to keep this!
		}
		this.startPinger();
	}
	userPing(evt) {
		if (this.detail) {
			const dets = JSON.parse(JSON.stringify(this.detail));
			dets.action = `ping`;
			const now = new Date();
			dets.time = now.toISOString();		
			this.postDetail(dets);
		}
	}
	postDetail(detail_param) {
		if (!this._post_detail_logged) {
			console.log('UserLogger::postDetail : detail = ', detail_param);
			this._post_detail_logged=true;
		}
		// crude but effective deep-clone
		const detail = JSON.parse(JSON.stringify(detail_param));
		detail.name = `*` + this.detail.name;	// we differentiate viewers with the *		
		detail.uuid = this.getUUID();
		// console.log(`VeedoPlayer.Prefix = `, VeedoPlayer.Prefix);
		const postUrl = this.url(`${VeedoPlayer.Prefix}rest/user/action`);
		console.log(`posting detail `, detail, ` to `, postUrl);
		fetch(postUrl, {
			method: 'POST',
			body: JSON.stringify(detail)
		})
		.then( res=>res.json() )
		.then( ret=>{
			if (!ret.hasOwnProperty("allowed") || ret.allowed){
				document.userNamed = true; 
			} else {
				document.userNamed = false;
				document.body.dispatchEvent(new CustomEvent(`veedo-login-failed`, {
					bubbles: true, 
					composed: true, 
				}));

			}
		})
		.catch (err => {
			console.log(`user detail failed: `, detail);
			console.log(err);
			//alert(`Error setting username: `, err);
		});
	}
	getUUID() {
		// localstorage will always be per-fqdn, whereas I want this to be shared
		// for *.veedo.live - so need to use a cookie, not localstorage
		const key = 'veedo.mediaserver.uuid';
		let uuid = localStorage.getItem(key);
		if (uuid) {
			return uuid;
		}
		uuid = crypto.randomUUID ? crypto.randomUUID() : 
				(function () {
		  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
		    (+c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> +c / 4).toString(16)
		  );
		})();
		localStorage.setItem(key, uuid);
		return uuid;
	}
	leaveEvent(evt) {
		if (this.detail) {
			this.detail.action = `leave`;
		}
	}
}
